import { API } from '@/constant/constants'
import { Floor } from '@/types/floor'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export const floorApi = {
  getByLocationId(locationId?: string, params: { requiredOverylay?: number } = {}) {
    const url = `${API.OPERATIONS.FLOOR.DEFAULT}/${locationId}`
    return axiosClient.get<Floor[]>(url + queryStringify(params))
  },
}

export default floorApi
